var _templateObject, _templateObject2;
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import { css } from "styled-components";
import { breakpoints as BreakpointMap } from "@nib-components/theme"; //StyledComponentsInterpolation;
export var breakpoint = function breakpoint(gte, lt) {
  /* eslint-disable @typescript-eslint/no-explicit-any */return function (strings) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }
    return function (_ref) {
      var theme = _ref.theme;
      return _breakpoint(theme.breakpoints || BreakpointMap, gte, lt).apply(void 0, [strings].concat(interpolations));
    };
  };
};
export function _breakpoint(breakpoints, gte, lt) {
  if (typeof lt === "undefined") {
    return _gte(breakpoints, gte);
  } else {
    return _between(breakpoints, gte, lt);
  }
}
export function _gte(breakpoints, name) {
  return withSingleCriteria(breakpoints, name, "min-width");
}
export function _between(breakpoints, gte, lt) {
  var gteValue = getValueFromName(breakpoints, gte);
  var ltValue = getValueFromName(breakpoints, lt); /* eslint-disable @typescript-eslint/no-explicit-any */
  return function (strings) {
    for (var _len2 = arguments.length, interpolations = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      @media (min-width: ", "em) and (max-width: ", "em) {\n        ", "\n      }\n    "])), convertPxToEm(gteValue), convertPxToEm(ltValue - 1), css.apply(void 0, [strings].concat(interpolations)));
  };
}
function withSingleCriteria(breakpoints, name, operator) {
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var value = getValueFromName(breakpoints, name); // special case for 0 to avoid wrapping styles in an unnecessary @media block
  if (operator === "min-width" && value === 0) {
    /* eslint-disable @typescript-eslint/no-explicit-any */return function (strings) {
      for (var _len3 = arguments.length, interpolations = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        interpolations[_key3 - 1] = arguments[_key3];
      }
      return css.apply(void 0, [strings].concat(interpolations));
    };
  }
  return function (strings) {
    for (var _len4 = arguments.length, interpolations = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      interpolations[_key4 - 1] = arguments[_key4];
    }
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      @media (", ": ", "em) {\n        ", "\n      }\n    "])), operator, convertPxToEm(value + offset), css.apply(void 0, [strings].concat(interpolations)));
  };
}
function getValueFromName(breakpoints, name) {
  if (!(name in breakpoints)) {
    console.error("breakpoint: Breakpoint \"".concat(name, "\" was not found."));
    return 0;
  }
  return breakpoints[name];
}
function convertPxToEm(pixels) {
  // @media is always calculated off 16px regardless of whether the root font size is the default or not
  return pixels / 16;
}
export function map(value, mapValueToCSS) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return _map(theme.breakpoints || BreakpointMap, value, mapValueToCSS);
  };
}
export function _map(breakpoints, value, mapValueToCSS) {
  var values = value;
  if (values === null || _typeof(values) !== "object") {
    return mapValueToCSS(values);
  }
  return [mapValueToCSS(undefined)].concat(_toConsumableArray(Object.keys(values).map(function (name) {
    var tag = _gte(breakpoints, name); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var val = values[name]; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    var styles = tag([], [].concat(mapValueToCSS(val)));
    return styles;
  })));
}